import React, { PureComponent } from 'react';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { PDFReader } from 'reactjs-pdf-reader';
import { showNotificationAutoDestroy } from '../ShowNotification';
import {
  FILE_INVALID_TYPE,
  FILE_TO_LARGE,
  MEGA_BYTES_1,
} from '../../utils/constants';

class DropZoneField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    t: PropTypes.func.isRequired,
    customHeight: PropTypes.bool,
    showRemoveButton: PropTypes.bool,
    showViewButton: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
        })
      ),
    ]).isRequired,
    maxSize: PropTypes.number,
  };

  static defaultProps = {
    customHeight: false,
    maxSize: 10000000,
    disabled: false,
    showRemoveButton: true,
    showViewButton: true,
  };

  constructor() {
    super();
    this.state = {};
    this.onDrop = this.onDrop.bind(this);
    this.onDropRejected = this.onDropRejected.bind(this);
  }

  onDrop(file) {
    const { onChange } = this.props;

    if (file) {
      if (file.length) {
        onChange(
          file.map((fl) =>
            Object.assign(fl, {
              preview: URL.createObjectURL(fl),
            })
          )
        );
      }
    }
  }

  onDropRejected(filesRejected) {
    const { t, maxSize } = this.props;

    if (filesRejected) {
      if (filesRejected[0].errors[0].code === FILE_INVALID_TYPE) {
        showNotificationAutoDestroy(
          'warning',
          t('notifications.attention'),
          `${t('notifications.warning-invalid-format')}`
        );
      } else if (filesRejected[0].errors[0].code === FILE_TO_LARGE) {
        showNotificationAutoDestroy(
          'warning',
          t('notifications.attention'),
          `${t('notifications.file-large')} ${maxSize / MEGA_BYTES_1} ${t(
            'general.mb'
          )}`
        );
      }
    }
  }

  removeFile(index, e) {
    const { onChange, value } = this.props;
    e.preventDefault();
    onChange(value.filter((val, i) => i !== index));
  }

  render() {
    const {
      value,
      customHeight,
      name,
      t,
      maxSize,
      disabled,
      showRemoveButton,
      showViewButton,
    } = this.props;
    const files = value;
    return (
      <div
        className={`dropzone dropzone--single${
          customHeight ? ' dropzone--custom-height' : ''
        }`}
      >
        <Dropzone
          accept="image/jpeg, image/png, application/pdf"
          name={name}
          disabled={disabled}
          multiple={false}
          maxSize={maxSize}
          onDropRejected={this.onDropRejected}
          onDrop={(fileToUpload) => {
            this.onDrop(fileToUpload);
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="dropzone__input">
              {(!files || files.length === 0) && (
                <div className="dropzone__drop-here">
                  <span className="lnr lnr-upload" /> {t('general.load-file')}
                </div>
              )}
              <input {...getInputProps()} />
            </div>
          )}
        </Dropzone>
        {files && Array.isArray(files) && files.length > 0 && (
          <aside className="dropzone__img">
            {files[0].type === 'application/pdf' ? (
              <PDFReader url={files[0].preview} />
            ) : (
              <img src={files[0].preview} alt="drop-img" />
            )}
            <p className="dropzone__img-name">{files[0].name}</p>
            {showRemoveButton ? (
              <button
                className="dropzone__img-delete"
                type="button"
                onClick={(e) => this.removeFile(0, e)}
              >
                {t('general.remove-file')}
              </button>
            ) : null}
            {showViewButton ? (
              <button
                className="dropzone__img-view"
                type="button"
                onClick={() => window.open(files[0].preview)}
              >
                {t('general.view-file')}
              </button>
            ) : null}
          </aside>
        )}
      </div>
    );
  }
}

const renderDropZoneField = (props) => {
  const {
    input,
    customHeight,
    t,
    maxSize,
    disabled,
    showRemoveButton,
    showViewButton,
  } = props;
  return (
    <DropZoneField
      {...input}
      t={t}
      disabled={disabled}
      customHeight={customHeight}
      maxSize={maxSize}
      showRemoveButton={showRemoveButton}
      showViewButton={showViewButton}
    />
  );
};

renderDropZoneField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    showRemoveButton: PropTypes.bool,
    showViewButton: PropTypes.bool,
  }).isRequired,
  customHeight: PropTypes.bool,
  t: PropTypes.func.isRequired,
  maxSize: PropTypes.number,
};

renderDropZoneField.defaultProps = {
  customHeight: false,
  maxSize: 10000000,
  disabled: false,
  showRemoveButton: true,
  showViewButton: true,
};
export default withTranslation('common')(renderDropZoneField);
